import './MsrpDisclaimer.scss';

const MsrpDisclaimer = ()=>{
    return (
    <div className="msrptxt-container">
        <ul className="msrptxt">
            <li>MSRP, or Manufacturers Suggested Retail Price, is determined by the manufacturer of each brand, make and model and may not reflect the price at which vehicles are sold in your region. The Best Offer shown is a national average of the live date and may not reflect the price at which vehicles are sold at the dealership you have chosen.</li>
        </ul>
    </div>)
}

export default MsrpDisclaimer;